<div>
  <div class="flex flex-row justify-start items-center">
    <div class="page-title">
      <h1>Client File Manager</h1>
    </div>
  </div>
</div>
